'use strict';

exports.__esModule = true;
exports.default = locationReducer;

var _ActionTypes = require('./ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function locationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  if (action.type === _ActionTypes2.default.UPDATE_LOCATION) {
    return action.payload;
  }

  return state;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/farce/lib/locationReducer.js
// module id = 675
// module chunks = 0